import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { canSeeAnder } from '../lib/anderAccess';
import { RequireAuth } from './RequireAuth';
import { Spinner } from './ui';

/** Runs after RequireAuth has resolved loading and confirmed a user, as RoleOnly does. */
function AnderOnly({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (!canSeeAnder(user?.role)) {
    return <Navigate to="/trips" replace />;
  }

  return <>{children}</>;
}

/**
 * Route guard for the signed-in Ander pages: the conversations, the trip
 * workspace and the rest of the portal. Sign-in first; then anyone Ander is
 * not shown to yet is sent to their trips.
 */
export function RequireAnder({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <AnderOnly>{children}</AnderOnly>
    </RequireAuth>
  );
}

/**
 * `/ander`, the preview before an account. Anyone Ander is not shown to yet is
 * sent to the home page rather than to sign in, which would say there was
 * something behind the address.
 */
export function AnderDoor({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-primary">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!canSeeAnder(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
